(() => {
  const cardSelector = "[data-kbd-product-card]";
  const normalize = (value) => String(value || "").trim().toLowerCase();

  const formatMoney = (cents) => {
    const themeObject = window.theme;
    const format = themeObject && (themeObject.moneyFormatWithCodeForProductsPreference || themeObject.moneyFormat);

    if (themeObject && themeObject.Shopify && typeof themeObject.Shopify.formatMoney === "function" && format) {
      return themeObject.Shopify.formatMoney(cents, format);
    }

    const currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active || "USD";
    return new Intl.NumberFormat(document.documentElement.lang || "en", {
      style: "currency",
      currency
    }).format(cents / 100);
  };

  const collectDefaultVariants = (optionSet) => {
    const variants = new Map();

    const visit = (node) => {
      if (!node || typeof node !== "object") return;
      if (Array.isArray(node)) {
        node.forEach(visit);
        return;
      }

      if (Array.isArray(node.option_values) && node.default_value != null) {
        const defaults = Array.isArray(node.default_value) ? node.default_value : [node.default_value];
        const defaultValues = defaults.map(normalize).filter(Boolean);

        node.option_values.forEach((option) => {
          const isDefault = defaultValues.includes(normalize(option.value)) || defaultValues.includes(normalize(option.id));
          if (isDefault && option.variant_id && option.product_handle) {
            variants.set(String(option.variant_id), {
              id: String(option.variant_id),
              handle: option.product_handle
            });
          }
        });
      }

      Object.values(node).forEach(visit);
    };

    visit(optionSet);
    return [...variants.values()];
  };

  const fetchVariantPrices = async (handles) => {
    const uniqueHandles = [...new Set(handles.filter(Boolean))];
    if (!uniqueHandles.length) return new Map();

    const response = await fetch(`/apps/options/variants?handles=${encodeURIComponent(uniqueHandles.join(","))}`, {
      credentials: "same-origin"
    });
    if (!response.ok) return new Map();

    const variants = await response.json();
    return new Map(variants.map((variant) => [String(variant.id), Number(variant.price) || 0]));
  };

  const updateCards = async () => {
    const configs = window.GPOConfigs;
    const cards = [...document.querySelectorAll(`${cardSelector}:not([data-kbd-addon-processed])`)];
    if (!configs || !configs.productOptionSetMap || !configs.options || !cards.length) return false;

    const cardDefaults = new Map();
    const allDefaultVariants = new Map();

    cards.forEach((card) => {
      const mappedSets = String(configs.productOptionSetMap[card.dataset.productId] || "")
        .split(",")
        .map((value) => value.trim())
        .filter(Boolean);
      const defaults = new Map();

      mappedSets.forEach((setId) => {
        collectDefaultVariants(configs.options[setId]).forEach((variant) => {
          defaults.set(variant.id, variant);
          allDefaultVariants.set(variant.id, variant);
        });
      });

      cardDefaults.set(card, [...defaults.values()]);
    });

    const prices = await fetchVariantPrices([...allDefaultVariants.values()].map((variant) => variant.handle));

    cardDefaults.forEach((defaults, card) => {
      const addonCents = defaults.reduce((total, variant) => total + (prices.get(variant.id) || 0), 0);
      card.dataset.kbdAddonProcessed = "true";
      if (!addonCents) return;

      const basePrice = Number(card.dataset.productPrice) || 0;
      const baseComparePrice = Number(card.dataset.productComparePrice) || 0;
      const priceElement = card.querySelector("[data-kbd-card-price]");
      const compareElement = card.querySelector("[data-kbd-card-compare-price]");

      if (priceElement) {
        priceElement.textContent = formatMoney(basePrice + addonCents);
        priceElement.dataset.kbdAddonAmount = String(addonCents);
      }

      if (compareElement && baseComparePrice > basePrice) {
        compareElement.textContent = formatMoney(baseComparePrice + addonCents);
      }
    });

    return true;
  };

  let attempts = 0;
  const initialize = async () => {
    attempts += 1;
    const updated = await updateCards();
    if (!updated && attempts < 30) window.setTimeout(initialize, 200);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize, { once: true });
  } else {
    initialize();
  }

  let observerTimer;
  const observer = new MutationObserver((mutations) => {
    const hasNewCards = mutations.some((mutation) => [...mutation.addedNodes].some((node) => {
      if (!(node instanceof Element)) return false;
      return node.matches(cardSelector) || node.querySelector(cardSelector);
    }));
    if (!hasNewCards) return;

    window.clearTimeout(observerTimer);
    observerTimer = window.setTimeout(updateCards, 80);
  });
  observer.observe(document.getElementById("MainContent") || document.body, {
    childList: true,
    subtree: true
  });
})();
